import React from 'react';
import classnames from 'classnames';

export default function createIcon(svg, defaultClassName) {
  return ({ size = 'base', className, ...otherProps }) => {
    const classes = classnames([
      'c-icon',
      `c-icon--size-${size}`,
      className,
      defaultClassName,
    ]);

    return React.cloneElement(svg, { className: classes, ...otherProps });
  };
}

export const SearchIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M42.33,39.5l21,21a2,2,0,1,1-2.83,2.83l-21-21a24,24,0,1,1,2.83-2.83ZM24,44A20,20,0,1,0,4,24,20,20,0,0,0,24,44Z"
    />
  </svg>
);

export const AvailablityIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M60.3,10.7c-0.8-0.9-2-1.3-3.2-1.3h-4.6V5.7c0-1.5-0.6-3-1.7-4c-1-1.1-2.5-1.7-4-1.7h-2.3c-1.5-0.1-3,0.5-4,1.7
      c-1.1,1.1-1.7,2.5-1.7,4v3.4H25.1V5.7c0.1-1.5-0.5-3-1.7-4c-1.1-1.1-2.5-1.7-4-1.7h-2.3c-1.5-0.1-3,0.5-4,1.7
      c-1.1,1.1-1.7,2.5-1.7,4v3.4H6.9c-1.3,0-2.4,0.6-3.2,1.5c-0.9,0.8-1.3,2-1.3,3.2v45.6c0,1.2,0.5,2.4,1.3,3.2c0.8,0.9,2,1.3,3.2,1.3
      h50.2c2.5,0,4.5-2.1,4.6-4.6V13.7C61.6,12.5,61.1,11.4,60.3,10.7z M17.2,59.5H6.9V49h10.2L17.2,59.5z M17.2,46.9H6.9V35.4h10.2
      L17.2,46.9z M17.2,33.2H6.9V22.8h10.2L17.2,33.2z M16.3,16.8C16.1,16.6,16,16.3,16,16V5.7c0-0.6,0.5-1.1,1.1-1.1h2.3
      c0.6,0,1.1,0.5,1.1,1.1V16c0,0.6-0.5,1.1-1.1,1.1h-2.3C16.8,17.1,16.6,17,16.3,16.8z M30.8,59.4H19.4V49h11.4L30.8,59.4z M30.8,46.8
      H19.4V35.4h11.4L30.8,46.8z M30.8,33.1H19.4V22.8h11.4L30.8,33.1z M44.5,59.4H33.1V49h11.4L44.5,59.4z M44.5,46.8H33.1V35.4h11.4
      L44.5,46.8z M44.5,33.1H33.1V22.8h11.4L44.5,33.1z M43.8,16.8c-0.2-0.2-0.4-0.5-0.4-0.8V5.7c0-0.6,0.5-1.1,1.2-1.1h2.3
      c0.6,0,1.1,0.5,1.1,1.1V16c0,0.6-0.5,1.1-1.1,1.1h-2.3C44.3,17.1,44,17,43.8,16.8z M57.1,59.4H46.8V49h10.3V59.4z M57.1,46.8H46.8
      V35.4h10.3V46.8z M57.1,33.1H46.8V22.8h10.3V33.1z"
    />
  </svg>
);

export const EyeIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M32 23.1C33.5 23.1 35 23.5 36.3 24.3 37.7 25.1 38.7 26.1 39.5 27.5 40.3 28.8 40.7 30.3 40.7 31.8 40.7 33.4 40.3 34.8 39.5 36.1 38.7 37.5 37.7 38.6 36.3 39.3 35 40.1 33.5 40.5 32 40.5 30.5 40.5 29 40.1 27.7 39.3 26.3 38.6 25.3 37.5 24.5 36.1 23.7 34.8 23.3 33.4 23.3 31.8 23.3 30.3 23.7 28.8 24.5 27.5 25.3 26.1 26.3 25.1 27.7 24.3 29 23.5 30.5 23.1 32 23.1ZM32 46.4C34.6 46.4 37.1 45.7 39.3 44.4 41.5 43.1 43.3 41.4 44.6 39.1 45.9 36.9 46.6 34.5 46.6 31.8 46.6 29.2 45.9 26.7 44.6 24.5 43.3 22.3 41.5 20.5 39.3 19.2 37.1 17.9 34.6 17.3 32 17.3 29.3 17.3 26.9 17.9 24.7 19.2 22.4 20.5 20.7 22.3 19.4 24.5 18.1 26.7 17.4 29.2 17.4 31.8 17.4 34.5 18.1 36.9 19.4 39.1 20.7 41.4 22.4 43.1 24.7 44.4 26.9 45.7 29.3 46.4 32 46.4ZM32 10C36.8 10 41.3 10.9 45.7 12.8 49.8 14.6 53.5 17.2 56.7 20.5 59.9 23.8 62.3 27.5 64 31.8 62.3 36.1 59.9 39.9 56.7 43.1 53.5 46.4 49.8 49 45.7 50.8 41.3 52.6 36.8 53.6 32 53.6 27.2 53.6 22.7 52.6 18.3 50.8 14.2 49 10.5 46.4 7.3 43.1 4.1 39.9 1.7 36.1 0 31.8 1.7 27.5 4.1 23.8 7.3 20.5 10.5 17.2 14.2 14.6 18.3 12.8 22.7 10.9 27.2 10 32 10Z"
    />
  </svg>
);

export const ConversationIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M62.89,22.56H39.56v-18a1.11,1.11,0,0,0-1.11-1.11H1.11A1.11,1.11,0,0,0,0,4.56V34.78a1.11,1.11,0,0,0,1.11,1.11H15.25L18.93,41a1.11,1.11,0,0,0,.9.46h0a1.11,1.11,0,0,0,.9-0.48l3.51-5.11h0.19v18A1.11,1.11,0,0,0,25.56,55H39.69l3.68,5.13a1.11,1.11,0,0,0,.9.46h0a1.11,1.11,0,0,0,.9-0.48L48.7,55H62.89A1.11,1.11,0,0,0,64,53.89V23.67A1.11,1.11,0,0,0,62.89,22.56ZM23.79,33.67a1.12,1.12,0,0,0-1,.48l-2.95,4.29-3.07-4.28a1.11,1.11,0,0,0-.41-0.35l-0.06,0a1.11,1.11,0,0,0-.49-0.11H2.22v-28H37.33V22.56H25.56a1.11,1.11,0,0,0-1.11,1.11v10H23.79Zm38,19.11H48.24a1.12,1.12,0,0,0-1,.48l-2.95,4.29-3.07-4.28a1.11,1.11,0,0,0-.41-0.35l-0.06,0a1.11,1.11,0,0,0-.49-0.11H26.67v-28H61.78v28Z"
    />
  </svg>
);

export const ResponsesIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M34.67,44.51A2,2,0,0,1,36,44H58a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H6A2,2,0,0,0,4,6V42a2,2,0,0,0,2,2H18a2,2,0,0,1,2,2V57.55ZM16,48H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0H58a6,6,0,0,1,6,6V42a6,6,0,0,1-6,6H36.76L19.33,63.49A2,2,0,0,1,16,62Zm0-20a4,4,0,1,0-4-4A4,4,0,0,0,16,28Zm16,0a4,4,0,1,0-4-4A4,4,0,0,0,32,28Zm16,0a4,4,0,1,0-4-4A4,4,0,0,0,48,28Z"
    />
  </svg>
);

export const MessageIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M60,18V12H4v6a2,2,0,0,1,.79.16L32,29.82,59.21,18.16A2,2,0,0,1,60,18Zm0,4.18L32.77,33.84a2,2,0,0,1-1.58,0L4,22.18V52H60ZM4,8H60a4,4,0,0,1,4,4V52a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V12A4,4,0,0,1,4,8Z"
    />
  </svg>
);

/**
 * Use this Icon when representing Project,
 * so you can swap out the code later
 * and not have to change the component name
 */
export const ProjectIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M8,16a4,4,0,0,0-4,4V52a4,4,0,0,0,4,4H56a4,4,0,0,0,4-4V20a4,4,0,0,0-4-4Zm0-4H56a8,8,0,0,1,8,8V52a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V20A8,8,0,0,1,8,12Zm32,0a8,8,0,0,0-16,0Zm4,20H20v6a2,2,0,0,1-4,0V32H4V28H60v4H48v6a2,2,0,0,1-4,0ZM32,0A12,12,0,0,1,44,12v4H20V12A12,12,0,0,1,32,0Z"
    />
  </svg>
);

export const CreateProjectIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M47.21,11.06,21,37.28l-1.44,7.09,7.09-1.44L52.86,16.71ZM50,8.23l5.66,5.66,3.06-3.06A4,4,0,0,0,53.1,5.17ZM17.39,35.3l33-33A8,8,0,0,1,61.66,13.65l-33,33L17.47,48.88a2,2,0,0,1-2.36-1.56,2.1,2.1,0,0,1,0-.79ZM4,60H48V36a2,2,0,0,1,4,0V62a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H28a2,2,0,0,1,0,4H4Z"
    />
  </svg>
);

export const ContractIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M50,60h2a8,8,0,0,0,8-8V4H20V46H16V64H50ZM64,0V52A12,12,0,0,1,52,64H16V0ZM30,16H50a2,2,0,0,0,0-4H30a2,2,0,0,0,0,4Zm0,12a2,2,0,0,1,0-4H42a2,2,0,0,1,0,4ZM44,44v8a8,8,0,0,0,6.4,7.84l1.6.33V64H14A14,14,0,0,1,0,50V44H44Zm-4,8V48H4v2A10,10,0,0,0,14,60H43.06A12,12,0,0,1,40,52Z"
    />
  </svg>
);

export const StarIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M32,50.9,15.59,63.44a2.7,2.7,0,0,1-3.79-.5l-.1-.14a3,3,0,0,1-.4-2.62L17.62,40,1.15,26.56a3,3,0,0,1-.62-4.07,2.75,2.75,0,0,1,2.26-1.21H23.11L29.35,2A2.76,2.76,0,0,1,32.77.11l.08,0A2.85,2.85,0,0,1,34.65,2l6.24,19.31H61.21A2.85,2.85,0,0,1,64,24.19a3,3,0,0,1-1.15,2.37L46.38,40,52.7,60.18a3,3,0,0,1-1.78,3.68,2.68,2.68,0,0,1-2.51-.42Z"
    />
    <path d="M38,25.34l-.9-2.78L32,6.83,26,25.34H5.91L22.25,38.57,16.19,58,32,45.86,47.81,58,41.75,38.57,58.07,25.29Z" />
  </svg>
);

export const PinIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M32 10.5c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.4-10-10-10zm0 17.1c-3.9 0-7.1-3.2-7.1-7.1s3.2-7.1 7.1-7.1 7.1 3.2 7.1 7.1-3.2 7.1-7.1 7.1z"
    />
    <path
      fill="currentColor"
      d="M52.9 16.9C50.6 7.1 42 .3 32 .3 20.2.3 10.6 9.9 10.6 21.7c0 11.1 18.4 39.9 19.2 41.1.5.8 1.3 1.2 2.2 1.2.9 0 1.7-.5 2.2-1.2.1-.1 7.7-12 13.2-23.4 2.9-5.9 4.7-10.6 5.5-14.1.3-1.4.5-2.6.5-3.6 0-1.6-.2-3.2-.5-4.8zm-2.4 4.8c0 .8-.1 1.8-.4 3-.7 3.3-2.5 7.8-5.3 13.5-4.9 10-11.4 20.4-12.8 22.6-6.5-10.3-18.4-31.1-18.4-39.1 0-10.2 8.3-18.5 18.4-18.5 8.6 0 16 5.9 18 14.3.3 1.4.5 2.8.5 4.2z"
    />
  </svg>
);

export const PeopleIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M43.6 34.1C46.1 34.1 48.9 34.5 51.9 35.3 55.3 36.1 58.1 37.3 60.2 38.7 62.7 40.4 64 42.2 64 44.3L64 51.6 46.6 51.6 46.6 44.3C46.6 40.4 44.7 37 40.9 34.3 41.5 34.2 42.4 34.1 43.6 34.1ZM20.4 34.1C22.9 34.1 25.7 34.5 28.7 35.3 32.1 36.1 34.9 37.3 36.9 38.7 39.5 40.4 40.7 42.2 40.7 44.3L40.7 51.6 0 51.6 0 44.3C0 42.2 1.3 40.4 3.8 38.7 5.9 37.3 8.7 36.1 12.1 35.3 15.1 34.5 17.9 34.1 20.4 34.1ZM20.4 28.4C18.9 28.4 17.5 28 16.1 27.2 14.8 26.5 13.7 25.4 12.9 24 12.1 22.7 11.7 21.2 11.7 19.7 11.7 18.2 12.1 16.7 12.9 15.4 13.7 14 14.8 13 16.1 12.2 17.5 11.4 18.9 11 20.4 11 22 11 23.4 11.4 24.7 12.2 26 13 27.1 14 27.9 15.4 28.6 16.7 29 18.1 29 19.7 29 21.3 28.6 22.7 27.9 24.1 27.1 25.4 26 26.5 24.7 27.2 23.4 28 22 28.4 20.4 28.4ZM43.6 28.4C42 28.4 40.6 28 39.3 27.2 37.9 26.5 36.8 25.4 36 24 35.3 22.7 34.9 21.2 34.9 19.7 34.9 18.2 35.3 16.7 36 15.4 36.8 14 37.9 13 39.3 12.2 40.6 11.4 42 11 43.6 11 45.1 11 46.5 11.4 47.9 12.2 49.2 13 50.3 14 51.1 15.4 51.9 16.7 52.3 18.2 52.3 19.7 52.3 21.2 51.9 22.7 51.1 24 50.3 25.4 49.2 26.5 47.9 27.2 46.5 28 45.1 28.4 43.6 28.4Z"
    />
  </svg>
);

export const ThumbsUpIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M16,60H49.34a6,6,0,0,0,5.89-4.86l4.62-24A6.13,6.13,0,0,0,60,30a6,6,0,0,0-6-6H34A2,2,0,0,1,33,23.72,2,2,0,0,1,32.27,21L36,14.7a7.05,7.05,0,0,0-5-10.61L19.7,23A2,2,0,0,1,18,24H16Zm-4,0V24H4V60ZM37.53,20H54a9.86,9.86,0,0,1,9.82,11.89l-4.62,24A10,10,0,0,1,49.35,64H2a2,2,0,0,1-2-2V22a2,2,0,0,1,2-2H16.87L28.29,1A2,2,0,0,1,30,0a11.05,11.05,0,0,1,9.48,16.75Z"
    />
  </svg>
);

export const ThumbsUpFillIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M16.87,20,28.29,1A2,2,0,0,1,30,0c6.11,0,9.06,4.95,9.06,11.06a11,11,0,0,1-1.58,5.69L35.53,20H54a9.86,9.86,0,0,1,9.82,11.89l-4.62,24A10,10,0,0,1,49.35,64H2a2,2,0,0,1-2-2V22a2,2,0,0,1,2-2ZM12,20V64h4V20Z"
    />
  </svg>
);

export const DeleteIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M44,8h.29l3.46,3.72,0,.28h-4ZM8.29,12l0-.28L11.72,8H12l.29,4Zm7.43,48H40.27L43.7,12H12.3Zm32-48L44.26,60.28a4,4,0,0,1-4,3.72H15.72a4,4,0,0,1-4-3.72L8.29,12H2A2,2,0,0,1,2,8H54a2,2,0,0,1,0,4ZM20,8H36V4H20Zm0-8H36a4,4,0,0,1,4,4v8H16V4A4,4,0,0,1,20,0Z"
    />
  </svg>
);

export const TooltipIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <circle cx="32" cy="32" r="32" />
    <path
      color="#ffffff"
      fill="currentColor"
      d="M28.66 48.28h6.04v6.32h-6.04zM42.05 12.82q-3.64-3.42-9.7-3.42-6.55 0-10.3 4T18.31 24h5.4a14.35 14.35 0 0 1 1.27-6q2-3.76 7.16-3.77 4.18 0 6 2.19A7.83 7.83 0 0 1 40 21.49a7.51 7.51 0 0 1-1.26 4.1 10.44 10.44 0 0 1-1.81 2.16l-2.48 2.4a18.54 18.54 0 0 0-4.59 6.09 19.68 19.68 0 0 0-1 7h5.41a14.44 14.44 0 0 1 .9-5.78A17.39 17.39 0 0 1 39 32.67a40.09 40.09 0 0 0 5.41-5.89 9.34 9.34 0 0 0 1.32-5.22 11.44 11.44 0 0 0-3.68-8.74z"
    />
  </svg>
);

export const InfoIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path d="M31.9 63.8C14.3 63.8 0 49.5 0 31.9S14.3 0 31.9 0s31.9 14.3 31.9 31.9-14.3 31.9-31.9 31.9zm0-61.8C15.4 2 2 15.4 2 31.9s13.4 29.9 29.9 29.9 29.9-13.4 29.9-29.9S48.4 2 31.9 2z" />
    <path d="M31.9 51.6c-.6 0-1-.4-1-1V22.9c0-.6.4-1 1-1s1 .4 1 1v27.7c0 .6-.4 1-1 1zM31.9 16.6c-.6 0-1-.4-1-1v-2.4c0-.6.4-1 1-1s1 .4 1 1v2.4c0 .6-.4 1-1 1z" />
  </svg>
);

export const TickThickIcon = createIcon(
  <svg viewBox="0 0 68.8 46.5">
    <path
      fill="currentColor"
      d="M67.7 1.2c-1.6-1.5-4.1-1.5-5.6 0L26.6 36.8l-19.7-20c-.7-.8-1.7-1.2-2.8-1.2-1.1 0-2.1.4-2.8 1.2-.9.8-1.3 1.8-1.3 2.8 0 1.1.4 2.1 1.2 2.8l22.6 22.8c.7.8 1.8 1.2 2.8 1.2 1.1 0 2.1-.4 2.8-1.2L67.7 6.8C68.4 6 68.8 5 68.8 4c0-1.1-.4-2.1-1.1-2.8z"
    />
  </svg>
);

export const ModalCloseIcon = createIcon(
  <svg viewBox="0 0 55 55">
    <path d="M33.1 27.5L53.8 6.8C54.6 6.1 55 5.1 55 4s-.4-2.1-1.2-2.8c-1.6-1.6-4.1-1.6-5.7 0L27.5 21.8 6.8 1.2C6.1.4 5.1 0 4 0S1.9.4 1.2 1.2C.4 1.9 0 2.9 0 4s.4 2.1 1.2 2.8l20.6 20.6L1.2 48.1c-1.6 1.6-1.6 4.1 0 5.7.7.7 1.7 1.2 2.8 1.2s2.1-.4 2.8-1.2l20.6-20.6L48 53.8c.8.8 1.8 1.2 2.8 1.2s2.1-.4 2.8-1.2c1.6-1.6 1.6-4.1 0-5.7L33.1 27.5z" />
  </svg>
);

export const CancelThickIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currenctColor"
      d="M37.7 32l20.6-20.6c.8-.8 1.2-1.8 1.2-2.8 0-1.1-.4-2.1-1.2-2.8-.8-.8-1.8-1.2-2.8-1.2-1.1 0-2.1.4-2.8 1.2L32 26.3 11.4 5.7c-.8-.8-1.8-1.2-2.8-1.2-1.1 0-2.1.4-2.8 1.2-.9.7-1.3 1.7-1.3 2.8 0 1.1.4 2.1 1.2 2.8L26.3 32 5.7 52.6c-.8.8-1.2 1.8-1.2 2.8 0 1.1.4 2.1 1.2 2.8 1.5 1.5 4.2 1.5 5.7 0L32 37.7l20.6 20.6c.8.8 1.8 1.2 2.8 1.2s2.1-.4 2.8-1.2c.8-.8 1.2-1.8 1.2-2.8 0-1.1-.4-2.1-1.2-2.8L37.7 32z"
    />
  </svg>
);

export const CloseIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <g>
      <path
        fill="#ffffff"
        d="M53.9,54c-12.1,12.1-31.8,12.1-43.9,0s-12.1-31.8,0-43.9s31.8-12.1,43.9,0S66.1,41.8,53.9,54z"
      />
      <path
        fill="currentColor"
        d="M32,64c-8.2,0-16.4-3.1-22.6-9.4C3.3,48.6,0,40.6,0,32c0-8.6,3.3-16.6,9.4-22.6c12.5-12.5,32.8-12.5,45.3,0 c6,6,9.4,14.1,9.4,22.6c0,8.6-3.3,16.6-9.4,22.6C48.4,60.9,40.2,64,32,64z M32,1.9c-7.7,0-15.4,2.9-21.3,8.8 C5.1,16.4,1.9,24,1.9,32c0,8,3.1, 15.6,8.8,21.3C22.5,65,41.5,65,53.3,53.3l0,0c5.7-5.7,8.8-13.2,8.8-21.3c0-8-3.1-15.6-8.8-21.3 C47.4,4.9,39.7,1.9,32,1.9z"
      />
    </g>
    <polygon
      fill="currentColor"
      points="40.4,38.9 34.2,32.6 40.4,26.4 37.9,23.9 31.7,30.1 25.4,23.9 23,26.4 29.2,32.6 23,38.9 25.4,41.3 31.7,35.1 37.9,41.3 "
    />
  </svg>
);

export const PlusIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M32,28V2a2,2,0,0,0-4,0V28H2a2,2,0,0,0,0,4H28V58a2,2,0,0,0,4,0V32H58a2,2,0,0,0,0-4Z"
    />
  </svg>
);

export const MinusIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path fill="currentColor" d="M4,30H60a2,2,0,0,1,0,4H4a2,2,0,0,1,0-4Z" />
  </svg>
);

export const ArrowUpThickIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path d="M6.5 46.437c1.6 1.6 4.1 1.5 5.6 0l20.2-20.3 19.8 19.9c.7.8 1.7 1.2 2.8 1.2 1.1 0 2.1-.4 2.8-1.2.8-.7 1.2-1.7 1.2-2.8 0-1.1-.4-2.1-1.2-2.8l-22.6-22.8c-.7-.8-1.8-1.2-2.8-1.2-1 0-2.1.4-2.8 1.2l-23.1 23.2c-.8.8-1.2 1.8-1.2 2.8.1 1.1.5 2.1 1.3 2.8z" />
  </svg>
);

export const ArrowDownThickIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path d="M57.6 17.6c-1.6-1.6-4.1-1.5-5.6 0L31.8 37.9 12 18c-.7-.8-1.7-1.2-2.8-1.2-1.1 0-2.1.4-2.8 1.2-.8.7-1.2 1.7-1.2 2.8 0 1.1.4 2.1 1.2 2.8L29 46.4c.7.8 1.8 1.2 2.8 1.2 1 0 2.1-.4 2.8-1.2l23.1-23.2c.8-.8 1.2-1.8 1.2-2.8-.1-1.1-.5-2.1-1.3-2.8z" />
  </svg>
);

export const ArrowLeftThickIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M46.47,57.57a4,4,0,0,0,0-5.6l-20.3-20.2L46.07,12a3.63,3.63,0,0,0,1.2-2.8,3.63,3.63,0,0,0-1.2-2.8,3.87,3.87,0,0,0-5.6,0L17.67,29a3.87,3.87,0,0,0,0,5.6l23.2,23.1a4,4,0,0,0,2.8,1.2A4.1,4.1,0,0,0,46.47,57.57Z"
    />
  </svg>
);

export const LoadingIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <g>
      <path d="M32,1A31,31,0,1,0,63,32,31,31,0,0,0,32,1Zm0,60A29,29,0,1,1,61,32,29,29,0,0,1,32,61Z" />
      <path
        fill="currentColor"
        d="M54.5,10.67A30.72,30.72,0,0,0,32,1V3A29,29,0,0,1,61,32h2A30.88,30.88,0,0,0,54.5,10.67Z"
      />
    </g>
  </svg>
);

export const EllipsisIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M6,38a6,6,0,1,1,6-6A6,6,0,0,1,6,38Zm26,0a6,6,0,1,1,6-6A6,6,0,0,1,32,38Zm26,0a6,6,0,1,1,6-6A6,6,0,0,1,58,38Z"
    />
  </svg>
);

export const LockedIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M8,28V60H56V28Zm0-4H56a4,4,0,0,1,4,4V60a4,4,0,0,1-4,4H8a4,4,0,0,1-4-4V28A4,4,0,0,1,8,24Zm12,0H44V16a12,12,0,0,0-24,0ZM32,0A16,16,0,0,1,48,16V28H16V16A16,16,0,0,1,32,0Zm0,48a4,4,0,1,0-4-4A4,4,0,0,0,32,48Zm0,4a8,8,0,1,1,8-8A8,8,0,0,1,32,52Z"
    />
  </svg>
);

export const ClockIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M32 60c15.464 0 28-12.536 28-28S47.464 4 32 4 4 16.536 4 32s12.536 28 28 28zm0 4C14.327 64 0 49.673 0 32 0 14.327 14.327 0 32 0c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32zm2-53a2 2 0 1 0-4 0v21a2 2 0 0 0 .586 1.414l8 8a2 2 0 0 0 2.828-2.828L34 31.172V11z"
    />
  </svg>
);

export const CalendarIcon = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M4 12v48h56V12H4zm0-4h56a4 4 0 0 1 4 4v48a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4zM1 28v-4h60.574v4H1zm15-13a2 2 0 1 1-4 0V2a2 2 0 1 1 4 0v13zm36 0a2 2 0 1 1-4 0V2a2 2 0 1 1 4 0v13z"
    />
  </svg>
);
